import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { MailWarning, X, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';

const API = `https://admin.krazybets.online/api`;

export default function VerifyEmailBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  if (!user || user.email_verified || dismissed) return null;

  const resend = async () => {
    setSending(true);
    try {
      const res = await axios.post(`${API}/auth/resend-verification`, { email: user.email });
      toast.success(res.data.message || 'Verification email sent');
      setSent(true);
    } catch (err) {
      toast.error('Could not send verification email. Try again in a minute.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      data-testid="verify-email-banner"
      className="bg-gradient-to-r from-amber-500/15 to-[#D4AF37]/15 border border-[#D4AF37]/40 rounded-lg p-4 mb-6 flex items-start gap-3"
    >
      {sent ? (
        <CheckCircle2 className="h-5 w-5 text-[#22C55E] mt-0.5 flex-shrink-0" />
      ) : (
        <MailWarning className="h-5 w-5 text-[#D4AF37] mt-0.5 flex-shrink-0" />
      )}
      <div className="flex-1 min-w-0">
        <p className="text-white font-semibold">
          {sent ? 'Check your inbox' : 'Verify your email to unlock betting'}
        </p>
        <p className="text-gray-300 text-sm mt-0.5">
          {sent
            ? `We just sent a new verification link to ${user.email}.`
            : `We sent a verification link to ${user.email}. Verify to place bets & withdraw funds.`}
        </p>
      </div>
      {!sent && (
        <Button
          onClick={resend}
          disabled={sending}
          className="btn-primary text-sm px-4 py-1.5 h-auto whitespace-nowrap"
          data-testid="verify-banner-resend-btn"
        >
          {sending ? 'Sending…' : 'Resend email'}
        </Button>
      )}
      <button
        onClick={() => setDismissed(true)}
        className="text-gray-400 hover:text-white p-1"
        data-testid="verify-banner-dismiss-btn"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
